export const generateId = () => Date.now() + parseInt(Math.random() * 1000, 10);
